import VueStore from '@/store';
import { isUuid } from '@/util/uuid';

export const fetchBrandData = async (route) => {
  const brandId = VueStore.getters['brand/currentBrandId'](route);
  const userBrand = VueStore.getters['user/brand'];

  if (!isUuid(brandId) && process.env.VUE_APP_SENTRY_DSN) {
    const Sentry = require('@sentry/vue');
    Sentry.withScope((scope) => {
      scope.setLevel('warning');
      scope.setTag('module', 'brand');
      scope.setTag('action', 'fetchBrandData');
      scope.setTag('errorType', 'invalid_brand_id');
      scope.setExtra('brandId', brandId);
      scope.setExtra('userBrand', userBrand);
      scope.setExtra('route', {
        name: route?.name,
        path: route?.path,
        fullPath: route?.fullPath,
        params: route?.params,
        query: route?.query,
      });
      scope.setExtra(
        'currentUrl',
        typeof window !== 'undefined' ? window.location.href : null,
      );
      Sentry.captureMessage('fetchBrandData resolved invalid brand id');
    });
  }

  await VueStore.dispatch('brand/fetchBrandInfo', brandId);

  await VueStore.dispatch(
    'ui/changeTheme',
    VueStore.getters['brand/brandTheme'],
  );
};
